var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ActionList',_vm._g({attrs:{"show-search":false,"load-items-callback":_vm.loadItemsCallback,"fixed-filters":_vm.fixedFilters,"allow-export":false},scopedSlots:_vm._u([{key:"item",fn:function({ item }){return [_c('SimplifiedPaymentListItem',_vm._g({key:item.uuid,attrs:{"payment":item}},_vm.$listeners))]}}])},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }